var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDepressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2050px",
    height: "2050px",
    viewBox: "0 0 2050 2050",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ffc500;}.cls-3{fill:#ff9f1e;}.cls-4{fill:#ffe059;}.cls-5{fill:#00305f;}.cls-6{fill:#4795ff;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 2040,
    width: 2040,
    x: 5,
    y: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 3",
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 1025,
    cy: 1025,
    r: 613.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1068.5,1551.8c-339,0-613.7-274.8-613.7-613.7a613.5,613.5,0,0,1,44.4-229.8A610.7,610.7,0,0,0,411.3,1025c0,338.9,274.8,613.7,613.7,613.7,257.7,0,478.3-158.8,569.2-383.9C1486.8,1432.8,1291.5,1551.8,1068.5,1551.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1025,411.3A610.4,610.4,0,0,0,659.9,531.7a706.9,706.9,0,0,1,453.2-18.9,27.8,27.8,0,0,0-3.3,5.1c-18.2,33.9,18.9,89.1,82.7,123.3s130.4,34.6,148.6.8a38.6,38.6,0,0,0,3.7-10.5c165.2,128,271.9,328.1,272.9,553.1a613.3,613.3,0,0,0,21-159.6C1638.7,686.1,1363.9,411.3,1025,411.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 1051.6,
    cy: 545.5,
    rx: 30.8,
    ry: 44,
    transform: "translate(53.4 1183.4) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1164.7,1266.9h0a506.4,506.4,0,0,0-279.4,0h0a137.4,137.4,0,0,1,137.4-137.4h4.6a137.4,137.4,0,0,1,137.4,137.4Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 793.2,
    cy: 930.8,
    rx: 94.9,
    ry: 93.5,
    transform: "translate(-171.1 1682.9) rotate(-87.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 759.7,
    cy: 897,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 833.1,
    cy: 956.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 772,
    cy: 969.1,
    r: 12.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 1254.8,
    cy: 930.8,
    rx: 94.9,
    ry: 93.5,
    transform: "translate(270.5 2144.1) rotate(-87.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1221.3,
    cy: 897,
    r: 24.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1294.7,
    cy: 956.7,
    r: 26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1233.6,
    cy: 969.1,
    r: 12.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M640.8,845.1a30,30,0,0,1-7-59.2,305.2,305.2,0,0,0,61-23.8c26.3-13.8,59.7-37.3,69.7-70.5A30,30,0,1,1,822,708.8c-12.8,42.5-47.6,79.6-100.6,107.1a349.9,349.9,0,0,1-73.6,28.3A28.6,28.6,0,0,1,640.8,845.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1409.2,845.1a28.6,28.6,0,0,1-7-.9,349.9,349.9,0,0,1-73.6-28.3c-53-27.5-87.8-64.6-100.6-107.1a30,30,0,1,1,57.5-17.2c19.8,66.1,129.6,94,130.7,94.3a30,30,0,0,1-7,59.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M686.8,1209.9h0a42.7,42.7,0,0,1-9.3-46.6l30.5-74a9.8,9.8,0,0,1,18,0l30.6,74a42.9,42.9,0,0,1-9.3,46.6h0A42.8,42.8,0,0,1,686.8,1209.9Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepressed);
export default __webpack_public_path__ + "static/media/depressed.c21359ad7bed009fe7bd9eb50f44f2f0.svg";
export { ForwardRef as ReactComponent };